/*
 * fn: catchOptionalRequest
 *
 * Catches an error from a request, swallows it and returns a fallback
 *
 */
import { unstable_rethrow } from 'next/navigation'

export const catchOptionalRequest =
  <T>(fallback: T, label?: string) =>
  (e: unknown): T => {
    unstable_rethrow(e)
    console.warn(`[requestUtil/catchOptionalRequest]${label ? ` ${label}` : ''}`, e)
    return fallback
  }
